import PropTypes from 'prop-types'

import cn from '@/utilities/cn'

const Option = ({ children, className, value, ...props }: any) => (
  <option className={cn('select__option', className)} value={value} {...props}>
    {children}
  </option>
)

Option.displayName = 'Option'

Option.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired
}

Option.defaultProps = {
  className: ''
}

export default Option
